<!-- navbar -->
<div class="header-layout">
<div id='navbar' class='container' >
	<div class='col nav-left px-0'>
		<a [href]="logoHref">
			<img alt="ClaveWinds" class='logosize' [src]="logoPath" loading="eager" decoding="async">
		</a>
	</div>
	<div class='flex-grow-1 form-search'>
		<div id="Buscador" class="nav-search form-inline">
			<div class="search-wrapper">
				<input
					type="text"
					[(ngModel)]="TxtBusqueda"
					(ngModelChange)="onInput($event)"
					(keydown)="onKeydown($event)"
					(blur)="onBlur()"
					class="form-control search-input"
					placeholder="Buscar en ClaveWinds.shop"
					autocomplete="off">

				<!-- Dropdown de sugerencias -->
				<div class="suggestions-dropdown" *ngIf="mostrarSugerencias || buscando">
					<div class="suggestions-loading" *ngIf="buscando && sugerencias.length === 0">
						<span class="spinner-border spinner-border-sm me-2"></span> Buscando...
					</div>
					<ul class="suggestions-list" *ngIf="sugerencias.length > 0">
						<li
							*ngFor="let prod of sugerencias; let i = index"
							class="suggestion-item"
							[class.active]="i === itemSeleccionado"
							(mousedown)="irAProducto(prod)">
							<img [src]="getImagen(prod)" [alt]="prod.Nombre" class="suggestion-img" loading="lazy">
							<div class="suggestion-info">
								<span class="suggestion-nombre">{{ prod.Nombre }}</span>
								<span class="suggestion-marca">{{ prod.Marca }}</span>
							</div>
							<span class="suggestion-precio">{{ getPrecio(prod) }}</span>
						</li>
					</ul>
					<div class="suggestions-footer" *ngIf="sugerencias.length > 0" (mousedown)="verTodosResultados()">
						Ver todos los resultados para "<strong>{{ TxtBusqueda }}</strong>"
					</div>
				</div>
			</div>

			<div class="nav-right">
				<div class="nav-search-submit nav-bg" (click)="VentanaProductos()">
					<i class='bx bx-search bx-sm'></i>
				</div>
			</div>
		</div>
	</div>
		<div class='col nav-right px-0'>
			<a href="#" class='nav-singin user-welcome' data-toggle="modal" data-target="#MdlLogin" (click)="OpenRegistro(MdlLogin)">
			Hola!, {{nombre}}
			›</a>
		<a href="#" class='nav-singin' data-toggle="modal" data-target="#MdlLogin" (click)="OpenRegistro(MdlLogin)">
			<i class='bx bx-user bx-sm'></i>
		</a>
		<a href="" role="button" aria-haspopup="true" data-toggle="dropdown" aria-expanded="false"
			(click)="abreCarrito()">
			<i class='bx bx-cart bx-sm' aria-hidden="true"><span id="CntPrd">{{TotalProd}}</span></i>
		</a>
		</div>
	</div>
		<div class="menu-navigation">
			<app-menu></app-menu>
		</div>
</div>

<!-- menu navegación -->

<!-- modal de registro -->
<ng-template #MdlLogin let-modal>
	<app-registro></app-registro>
</ng-template>
